<div class="prize-card__card-body">

    <div [ngClass]="{'prize-card__card-body__card-title': true, 'prize-carousel-title': true, 'title-xs': true}">
        <div [id]="'prize-name-' + prize.prizeId" class="prize-card__card-body__card-title__price"
            role="heading" [attr.aria-label]="prize.name || ''" aria-level="3">
            {{prize && prize.name ? prize.name: ''}}
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div [id]="'prize-description-' + prize.prizeId" class="prize-title title-xxs mb-0" [attr.aria-label]="prize.description || ''">{{prize && prize.description ?
                prize.description : ''}}</div>
            <div *ngIf="prize.availableCount && gameType == GAMETYPES.DIVISION" class="prize-detail">
                Limit {{prize.availableCount}}
            </div>
            <div *ngIf="prize.type == PRIZETYPES.SWEEPSTAKES && gameType == GAMETYPES.EPISODIC" class="prize-detail">
                Drawing held weekly
            </div>
            <div class="prize-card-reward-details-container">
                <a class="prize-card-reward-details reward-details" tabindex="0" [attr.aria-label]="'Open Details about ' + prize.name"
                    [attr.aria-describedby]="' prize-description-' + prize.prizeId + ' prize-expiration-' + prize.prizeId"
                    role="link" (click)="prizeDetailsHandler($event)" (keyup.enter)="prizeDetailsHandler($event)">
                    {{linktext}}
                </a>
            </div>
        </div>
        <div class="col-4">
            <picture>
                <source media="(min-width: {{md}})" srcset="{{getImageUrl(prize,'desktop')}}">
                <source media="(min-width: {{sm}})" srcset="{{getImageUrl(prize,'tablet')}}">
                <img loading="lazy" class="prize-image" src="{{getImageUrl(prize,'mobile')}}"
                    alt="" />
            </picture>
        </div>
    </div>
    <ng-container *ngIf="gameType === GAMETYPES.DIVISION">
        <div class="prize-flex-area">
            <button tabindex="0" *ngIf="prize.availableCount != 0" [attr.aria-label]="'Redeem ' + prizeRedeemTokenLabel(prize.burnPoints) + ' for ' + prize.name"
                [attr.aria-describedby]="' prize-description-' + prize.prizeId + ' prize-expiration-' + prize.prizeId"
                type="button" class="btn btn-md btn-secondary" [disabled]="isDisabled()" (click)="redeemPrize($event)">
                {{prizeRedeemTokenLabel(prize.burnPoints)}}
                </button>
            <button tabindex="0" *ngIf="prize.availableCount == 0"
                [attr.aria-describedby]="'prize-name-' + prize.prizeId + ' prize-description-' + prize.prizeId + ' prize-expiration-' + prize.prizeId"
                type="button" class="btn btn-md btn-secondary" disabled>Out of Stock</button>
            <ng-container *ngIf="showExpirationDate()">
                <div [id]="'prize-expiration-' + prize.prizeId" class="sr-only">Expires on {{ getSRExpirationDate() }}</div>
                <p class="expiration body-text-xs" aria-hidden="true">Expires {{expirationShortDate()}}</p>
            </ng-container>
        </div>
    </ng-container>
</div>